import React, { PureComponent } from 'react';
import TableHead from './Head';
import TableBody from './Body';
import SortableBody from './SortableBody';
import TableRow from './Row';
import TableCell from './Cell';
import style from './styles/style.module.css';

class Table extends PureComponent {
    constructor( props ) {
        super( props );
    }

    render() {
        const { children } = this.props;

        return (
            <div className={ `dl-table ${ style.table } ${ this.props.className }` } id={ this.props.id }>
                { children }
            </div>
        );
    }
    static Head = ( props ) => {
        return ( <TableHead { ...props } /> );
    }
    static Body = ( props ) => {
        return ( <TableBody { ...props } /> );
    }
    static SortableBody = ( props ) => {
        return ( <SortableBody { ...props } /> );
    }
    static Row = ( props ) => {
        return ( <TableRow { ...props } /> );
    }
    static Cell = ( props ) => {
        return ( <TableCell { ...props } /> );
    }
}
Table.defaultProps = {
    className: '',
};

export default Table;
